import { useRef, useState } from "react";
import {
  MoreVert as MoreVertIcon,
  //PictureAsPdfOutlined,
  Replay as ReplayIcon,
  //Share as ShareIcon,
} from "@mui/icons-material";
import {
  Button,
  ClickAwayListener,
  Grow,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import {
  CopyIcon,
  // FileIcon
} from "../../icons";
import { ToastManager } from "../Toast/ToastManager";

const AIChatAction = props => {
  const { userData, message, sendQuery, handleLogin } = props;
  const [actionMenu, setActionMenu] = useState(false);
  const anchorRef = useRef(null);

  const actionMenuToggle = () => {
    setActionMenu(prevOpen => !prevOpen);
  };
  const actionMenuClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setActionMenu(false);
  };

  const copyAction = () => {
    navigator.clipboard.writeText(message?.response);
    ToastManager.addToast({ title: "Copied!" });
  };
  const regenrateAction = () => {
    sendQuery(message?.query);
  };

  return userData ? (
    <div
      className={`events6ix-dropdown events-page-aichat-content-messages-box-action ${
        actionMenu ? "active" : ""
      }`}
    >
      <Button
        ref={anchorRef}
        variant="text"
        className={`events6ix-dropdown-btn events6ix-btn events6ix-btn-sm  events6ix-btn-secondary ${
          actionMenu ? "active" : ""
        }`}
        id="events-page-aichat-message-action-button"
        aria-controls={
          actionMenu ? "company-profile-banner-action-menu" : undefined
        }
        aria-expanded={actionMenu ? "true" : undefined}
        aria-haspopup="true"
        onClick={actionMenuToggle}
      >
        <MoreVertIcon />
      </Button>

      <Popper
        open={actionMenu}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-end"
        transition
        disablePortal
        className="events6ix-dropdown-menu"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-end" ? "right top" : "right bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={actionMenuClose}>
                <MenuList
                  autoFocusItem={actionMenu}
                  id="events-page-aichat-message-action-menu"
                  aria-labelledby="company-profile-banner-action-button"
                  className="events6ix-dropdown-list"
                >
                  <MenuItem
                    className="events6ix-dropdown-list-item"
                    onClick={e => {
                      actionMenuClose(e);
                      copyAction();
                    }}
                  >
                    <CopyIcon />
                    <ListItemText>Copy response</ListItemText>
                  </MenuItem>
                  {/* <MenuItem
                    className="events6ix-dropdown-list-item"
                    onClick={e => {
                      actionMenuClose(e);
                    }}
                  >
                    <FileIcon />
                    <ListItemText>Download response (TXT)</ListItemText>
                  </MenuItem> */}
                  {/* <MenuItem
                    className="events6ix-dropdown-list-item"
                    onClick={e => {
                      actionMenuClose(e);
                    }}
                  >
                    <PictureAsPdfOutlined fontSize="small" color="inherit" />
                    <ListItemText>Download response (PDF)</ListItemText>
                  </MenuItem> */}

                  <MenuItem
                    className="events6ix-dropdown-list-item"
                    onClick={e => {
                      actionMenuClose(e);
                      regenrateAction();
                    }}
                  >
                    <ReplayIcon fontSize="small" color="inherit" />
                    <ListItemText>Regenerate response</ListItemText>
                  </MenuItem>
                  {/* <MenuItem
                    className="events6ix-dropdown-list-item"
                    onClick={e => {
                      actionMenuClose(e);
                    }}
                  >
                    <ShareIcon fontSize="small" color="inherit" />
                    <ListItemText>Share with friends</ListItemText>
                  </MenuItem> */}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  ) : (
    <div className="events6ix-dropdown events-page-aichat-content-messages-box-action">
      <Button
        variant="text"
        className="events6ix-dropdown-btn events6ix-btn events6ix-btn-sm  events6ix-btn-secondary"
        onClick={handleLogin}
      >
        <MoreVertIcon />
      </Button>
    </div>
  );
};

export default AIChatAction;
